import React, { useEffect } from 'react';
import { updateContentDisplay } from './display';

const ContentStructureHandler = ({ pagedHtml, currentPage, contentRef }) => {
  // 響應 currentPage 變化，更新顯示
  useEffect(() => {
    if (pagedHtml && contentRef.current && currentPage >= 0) {
      updateContentDisplay(contentRef, currentPage);
    }
  }, [pagedHtml, currentPage, contentRef]);

  return null; // 此組件只負責邏輯處理，不渲染 UI
};

export default ContentStructureHandler;

